/**
 * LP用スクリプト（玉露とはモーダル等）
 */
(function () {
  var modal = document.getElementById('products_block_modal');
  if (!modal) return;

  var openBtn = document.querySelector('[data-products-modal-open]');
  var closeTriggers = document.querySelectorAll('[data-products-modal-close]');

  function openModal() {
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  if (openBtn) {
    openBtn.addEventListener('click', function () {
      openModal();
    });
  }

  closeTriggers.forEach(function (el) {
    el.addEventListener('click', function () {
      closeModal();
    });
  });

  modal.addEventListener('click', function (e) {
    if (e.target === modal || e.target.classList.contains('products_block__modal-overlay')) {
      closeModal();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) {
      closeModal();
    }
  });
})();

/**
 * Recommend ITEMS スライダー（SP のみ Splide）
 */
(function () {
  if (typeof Splide === 'undefined') return;

  var roots = document.querySelectorAll('[data-recommend-splide]');
  var SP_BREAKPOINT = 699;

  roots.forEach(function (root) {
    var splideInstance = null;
    var media = window.matchMedia('(max-width: ' + SP_BREAKPOINT + 'px)');

    function init() {
      if (media.matches) {
        if (!splideInstance) {
          root.classList.add('splide');
          splideInstance = new Splide(root, {
            type: 'loop',
            rewind: true,
            fixedWidth: 160,
            gap: 16,
            padding: 0,
            pagination: true,
            arrows: false,
            focus: 0,
            trimSpace: false,
            loop: true
          });
          splideInstance.mount();
        }
      } else {
        if (splideInstance) {
          splideInstance.destroy();
          splideInstance = null;
          root.classList.remove('splide');
        }
      }
    }

    media.addEventListener('change', init);
    init();
  });

  /**
   * Contents Block カードスライダー（SP のみ Splide / Figma 1-1239）
   */
  var cardsRoots = document.querySelectorAll('[data-contents-cards-splide]');
  cardsRoots.forEach(function (root) {
    var splideInstance = null;
    var media = window.matchMedia('(max-width: ' + SP_BREAKPOINT + 'px)');

    function init() {
      if (media.matches) {
        if (!splideInstance) {
          root.classList.add('splide');
          splideInstance = new Splide(root, {
            type: 'loop',
            rewind: true,
            fixedWidth: 160,
            gap: 16,
            padding: 0,
            pagination: true,
            arrows: false,
            focus: 0,
            trimSpace: false,
            loop: true
          });
          splideInstance.mount();
        }
      } else {
        if (splideInstance) {
          splideInstance.destroy();
          splideInstance = null;
          root.classList.remove('splide');
        }
      }
    }

    media.addEventListener('change', init);
    init();
  });
})();

/**
 * Contents Block 詳しく見るアコーディオン（SP のみ）
 */
(function () {
  var SP_BREAKPOINT = 699;
  var bodies = document.querySelectorAll('.contents_block__body');

  bodies.forEach(function (body) {
    var button = body.querySelector('[data-contents-accordion-toggle]');
    var panel = body.querySelector('[data-contents-columns-panel]');
    var media = window.matchMedia('(max-width: ' + SP_BREAKPOINT + 'px)');

    if (!button || !panel) return;

    function setOpen(isOpen) {
      body.classList.toggle('is-open', isOpen);
      button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      panel.style.maxHeight = isOpen ? panel.scrollHeight + 'px' : '0px';
    }

    function syncState() {
      if (media.matches) {
        setOpen(body.classList.contains('is-open'));
      } else {
        body.classList.add('is-open');
        button.setAttribute('aria-expanded', 'true');
        panel.style.maxHeight = 'none';
      }
    }

    body.classList.remove('is-open');

    button.addEventListener('click', function () {
      if (!media.matches) return;
      setOpen(!body.classList.contains('is-open'));
    });

    media.addEventListener('change', function () {
      if (media.matches) {
        body.classList.remove('is-open');
      }
      syncState();
    });

    window.addEventListener('resize', function () {
      if (media.matches && body.classList.contains('is-open')) {
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }
    });

    syncState();
  });
})();
